// extracted by mini-css-extract-plugin
export default {"itens":"Category_itens__xh0xY"};